import { useMutation } from '@tanstack/react-query';

import { type ZoneUserAccess } from 'src/features/parkingManagement/types/zoneUserAccess.ts';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { CreateZoneUserAccessFormSchemaValues as FormSchemaValues } from 'src/features/parkingManagement/api/ZoneUserAccess/useCreateZoneUserAccess.ts';

const RESOURCE = '/parkings/:parkingId/zone-user-access/:zoneUserAccessId/';

interface DTO extends FormSchemaValues {
    parkingId: string;
    zoneUserAccessId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, zoneUserAccessId, ...data }: DTO): Promise<ZoneUserAccess> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, zoneUserAccessId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateZoneUserAccess };
